export default function Label(props) {
	return <label className="dxp-mb-2 dxp-text-sm dxp-font-bold dxp-text-purple-900" htmlFor={props.for}>{props.title}</label>
}
